module.exports = __webpack_public_path__ + "img/login-bg.2e6ab15f.png";